module.exports = __webpack_public_path__ + "img/icon_group_2@2x.7aa6d101.png";